import { defineWidgetSettings } from "@nexus/widget-sdk";

/** What an author sets on the IP blocking summary. */
export const settings = defineWidgetSettings({
  id: "ip-blocking-summary",
  properties: {
    mode: {
      type: "string",
      title: "Measure",
      default: "safety",
      oneOf: [
        { const: "safety", title: "Safe to block" },
        { const: "volume", title: "Detected and sent IPs" },
        { const: "effectiveness", title: "Blocking effectiveness" },
      ],
      "x-ui": { category: "display", order: 10, summary: true, keepDefault: true },
    },
  },
});
